<script>
    export default {
        computed: {
            customColor() {
                const color = this.$store.getters.CUSTOM_COLOR.MAIN;
                const hex = this.rgbToHex(color.red, color.green, color.blue);
                return hex;
            },
        },
        methods: {
            changeColor(event) {
                const color = event.target.value;
                const red = parseInt(color.substr(1,2), 16);
                const green = parseInt(color.substr(3,2), 16);
                const blue = parseInt(color.substr(5,2), 16);

                this.$store.dispatch('CHANGE_ALL_CUSTOM_COLOR', {
                    red: red,
                    green: green,
                    blue: blue
                });
            },
            rgbToHex (r, g, b) {
                return '#' + [r, g, b].map(x => {
                    const hex = x.toString(16)
                    return hex.length === 1 ? '0' + hex : hex
                }).join('')
            }
        }
    }
</script>


<template>
    <input 
        type="color"
        @input="changeColor"
        :value="customColor"
    >
</template>


<style scoped>
    input[type=color]{
        width: 100%;
        height: 20px;
        border: none;
        background: none;
        margin-top: 5px;
    }
    input[type="color"]::-webkit-color-swatch-wrapper {
        padding: 0;
    }
    input[type="color"]::-webkit-color-swatch {
        border: var(--border);
        border-radius: 10px;
    }
</style>